import React from 'react';
import { Helmet } from 'react-helmet-async';

export interface MetaProps {
  title?: string;
  description?: string;
  keywords?: string;
  subject?: string;
  copyright?: string;
  language?: string;
  robots?: string;
  revised?: string;
  abstract?: string;
  topic?: string;
  summary?: string;
  Classification?: string;
  author?: string;
  designer?: string;
  replyTo?: string;
  owner?: string;
  url?: string;
  identifierUrl?: string;
  directory?: string;
  pagename?: string;
  category?: string;
  coverage?: string;
  distribution?: string;
  rating?: string;
  revisitAfter?: string;
  subtitle?: string;
  target?: string;
  HandheldFriendly?: string;
  MobileOptimized?: string;
  date?: string;
  searchDate?: string;
  medium?: string;
}

export const Meta: React.FC<MetaProps> = (props: MetaProps) => {
  const title = props.title ? `${props.title} | AWS Jam` : undefined;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {props.description && <meta name="description" content={props.description} />}
      {props.keywords && <meta name="keywords" content={props.keywords} />}
      {props.subject && <meta name="subject" content={props.description} />}
      {props.copyright && <meta name="copyright" content={props.copyright} />}
      {props.language && <meta name="language" content={props.language} />}
      {props.robots && <meta name="robots" content={props.robots} />}
      {props.revised && <meta name="revised" content={props.revised} />}
      {props.abstract && <meta name="abstract" content={props.abstract} />}
      {props.topic && <meta name="topic" content={props.topic} />}
      {props.summary && <meta name="summary" content={props.summary} />}
      {props.Classification && <meta name="Classification" content={props.Classification} />}
      {props.author && <meta name="author" content={props.author} />}
      {props.designer && <meta name="designer" content={props.designer} />}
      {props.replyTo && <meta name="reply-to" content={props.replyTo} />}
      {props.owner && <meta name="owner" content={props.owner} />}
      {props.url && <meta name="url" content={props.url} />}
      {props.identifierUrl && <meta name="identifier-URL" content={props.identifierUrl} />}
      {props.directory && <meta name="directory" content={props.directory} />}
      {props.pagename && <meta name="pagename" content={props.pagename} />}
      {props.category && <meta name="category" content={props.category} />}
      {props.coverage && <meta name="coverage" content={props.coverage} />}
      {props.distribution && <meta name="distribution" content={props.distribution} />}
      {props.rating && <meta name="rating" content={props.rating} />}
      {props.revisitAfter && <meta name="revisit-after" content={props.revisitAfter} />}
      {props.subtitle && <meta name="subtitle" content={props.subtitle} />}
      {props.target && <meta name="target" content={props.target} />}
      {props.HandheldFriendly && <meta name="HandheldFriendly" content={props.HandheldFriendly} />}
      {props.MobileOptimized && <meta name="MobileOptimized" content={props.MobileOptimized} />}
      {props.date && <meta name="date" content={props.date} />}
      {props.searchDate && <meta name="search_date" content={props.searchDate} />}
      {props.medium && <meta name="medium" content={props.medium} />}
    </Helmet>
  );
};
